import React from 'react';
import {HashRouter as Router,Routes,Route} from 'react-router-dom';
import {motion} from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Fixtures from './pages/Fixtures';
import Results from './pages/Results';
import Team from './pages/Team';
import Admin from './pages/Admin';
import PhotoManager from './pages/PhotoManager';
import PhotoManagerDebug from './pages/PhotoManagerDebug';
import EmergencyDebug from './pages/EmergencyDebug';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';
import './styles/newspaper.css';

function App() {
return (
<Router>
<div className="min-h-screen bg-gradient-to-br from-green-50 to-gray-50 flex flex-col">
<Header />
<motion.main
initial={{opacity: 0,y: 20}}
animate={{opacity: 1,y: 0}}
transition={{duration: 0.5}}
className="flex-grow"
>
<Routes>
<Route path="/" element={<Home />} />
<Route path="/fixtures" element={<Fixtures />} />
<Route path="/results" element={<Results />} />
<Route path="/team" element={<Team />} />
<Route path="/admin" element={<Admin />} />
<Route path="/photo-manager" element={<PhotoManager />} />
<Route path="/photo-manager-debug" element={<PhotoManagerDebug />} />
<Route path="/emergency-debug" element={<EmergencyDebug />} />
</Routes>
</motion.main>
<Footer />
</div>
</Router>
);
}

export default App;